var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoCoachesIconGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 37.436,
    viewBox: "0 0 36 37.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 31.216,
    height: 32.436,
    transform: "translate(-5 -5)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 15,
    height: 14.683,
    fill: "#989898"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16025",
    "data-name": "Group 16025",
    transform: "translate(-157 -344.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(162 354.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5321",
    "data-name": "Path 5321",
    d: "M17.433,13.848A7.061,7.061,0,0,0,23.03,11a6.667,6.667,0,0,0,1.327-4.071,6.924,6.924,0,1,0-6.924,6.924m0-11.448a4.524,4.524,0,1,1-4.524,4.524A4.527,4.527,0,0,1,17.433,2.4",
    transform: "translate(-6.825 0)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M10.608,41.374C6.132,41.374,0,41.374,0,48.106a1.2,1.2,0,0,0,1.2,1.2H20.016a1.2,1.2,0,0,0,1.2-1.2c0-6.732-6.132-6.732-10.608-6.732M2.5,46.906c.516-2.668,3-3.132,8.1-3.132s7.588.468,8.1,3.132Z",
    transform: "translate(0 -26.87)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    transform: "translate(178 344.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M12.805,0H2.195A2.025,2.025,0,0,0,0,1.857V9.648A2.025,2.025,0,0,0,2.195,11.5H5.17v1.982a1.2,1.2,0,0,0,2.071.818l2.607-2.8h2.957A2.025,2.025,0,0,0,15,9.648V1.857A2.025,2.025,0,0,0,12.805,0M6.377,9.118H2.4V2.387h10.21v6.73H9.336a1.2,1.2,0,0,0-.875.379l-.888.955v-.138a1.2,1.2,0,0,0-1.2-1.2",
    transform: "translate(0 0)",
    fill: "#989898"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoCoachesIconGrey);
export default __webpack_public_path__ + "static/media/co-coaches-icon-grey.47b314f9d2706acf854d7e6abd4e1996.svg";
export { ForwardRef as ReactComponent };